<script setup lang="ts">
defineOptions({
  name: 'ContentBlockContacts',
})

export interface Button {
  label?: Maybe<string>
  url?: Maybe<string>
}

interface Props {
  anchor?: Maybe<string>
  title?: string
  location?: Button
  phone?: Button
  email?: Button
}

const props = defineProps<Props>()

const hasItems = computed<boolean>(() => Boolean(props.location || props.phone || props.email))
</script>

<template>
  <SectionWrapper
    :anchor
    class="contacts"
  >
    <Wrapper>
      <div class="contacts__inner">
        <div class="contacts__heading">
          <UIDynamicHeading
            v-if="title"
            level="3"
            as="h2"
            class="contacts__title"
          >
            {{ title }}
          </UIDynamicHeading>
        </div>
        <div
          v-if="hasItems"
          class="contacts__list"
        >
          <ContentBlockContactsItem
            v-if="location"
            icon="tabler:map-pin-2"
            title="Location"
            :button="location"
          />
          <ContentBlockContactsItem
            v-if="phone"
            icon="icons8:phone"
            title="Phone"
            :button="phone"
          />
          <ContentBlockContactsItem
            v-if="email"
            icon="quill:mail"
            title="Email"
            :button="email"
          />
        </div>
      </div>
    </Wrapper>
  </SectionWrapper>
</template>

<style scoped lang="scss">
.contacts {
  @apply mb-[40px];
  @apply md:mb-[60px];
  @apply xl:mb-[100px];

  &__inner {
    @apply bg-primary/10 text-center py-[50px] -mx-[20px] rounded-[10px];
    @apply md:py-[60px] md:mx-0;
    @apply xl:py-[80px];
  }

  &__heading {
    @apply mb-[40px];
    @apply lg:mb-[60px];
  }

  &__title {
    @apply max-lg:text-[28px];
  }

  &__list {
    @apply flex flex-wrap justify-center gap-y-[40px];
    @apply xl:px-[10%];
  }
}
</style>
